module.exports = __webpack_public_path__ + "img/7.84e47632.jpg";